import { ChevronUpIcon, ChevronDownIcon } from "@heroicons/react/20/solid";
import { SIDEBAR_WIDTH } from "./SlideIndex";

interface Props {
  direction: "up" | "down";
  disabled: boolean;
  onClick: () => void;
  label: string;
}

// The arrow sits in the dark-blue gutter at the top or bottom of the slide
// area, inset 12px from the viewport edge so it never touches the edge.
// Horizontally centered in the (viewport − sidebar) region so it aligns with
// the slide card.
const EDGE_INSET = "12px";

export function NavArrow({ direction, disabled, onClick, label }: Props) {
  const Icon = direction === "up" ? ChevronUpIcon : ChevronDownIcon;
  const verticalAnchor =
    direction === "up" ? { top: EDGE_INSET } : { bottom: EDGE_INSET };

  return (
    <button
      type="button"
      aria-label={label}
      disabled={disabled}
      onClick={onClick}
      style={{
        ...verticalAnchor,
        left: `calc(${SIDEBAR_WIDTH}px + (100vw - ${SIDEBAR_WIDTH}px) / 2)`,
        transform: "translateX(-50%)",
      }}
      className="fixed z-20 flex h-6 w-6 items-center justify-center rounded-full bg-white text-slate-700 shadow-md transition hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-30"
    >
      <Icon className="h-4 w-4" />
    </button>
  );
}
